import {
	createActionsHook,
	createHook,
	createStore,
	type BoundActions,
	type HookActionsFunction,
	type HookReturnValue,
	type StoreActionApi,
} from 'react-sweet-state';

type State = {
	currentAuth: {
		url: string;
		authType: '3p' | 'forge';
		agentMessageId?: string;
	} | null;
};

const store = createStore({
	name: 'current-action-auth',
	initialState: {
		currentAuth: null,
	} as State,
	actions: {
		setAuth:
			({
				url,
				authType,
				agentMessageId,
			}: NonNullable<State['currentAuth']>): (({ setState }: StoreActionApi<State>) => void) =>
			({ setState }) => {
				setState({
					currentAuth: {
						url,
						authType,
						agentMessageId,
					},
				});
			},
		clearAuth:
			(): (({ setState }: StoreActionApi<State>) => void) =>
			({ setState }) => {
				setState({ currentAuth: null });
			},
	},
});

const useStore = createHook(store);
export const useCurrentActionAuthActions: HookActionsFunction<
	BoundActions<
		State,
		{
			setAuth: ({
				url,
				authType,
				agentMessageId,
			}: NonNullable<State['currentAuth']>) => ({ setState }: StoreActionApi<State>) => void;
			clearAuth: () => ({ setState }: StoreActionApi<State>) => void;
		}
	>
> = createActionsHook(store);

export const useCurrentActionAuth = (): HookReturnValue<
	State,
	BoundActions<
		State,
		{
			setAuth: ({
				url,
				authType,
				agentMessageId,
			}: NonNullable<State['currentAuth']>) => ({ setState }: StoreActionApi<State>) => void;
			clearAuth: () => ({ setState }: StoreActionApi<State>) => void;
		}
	>
> => {
	const store = useStore();

	return store;
};
